import { LogLevel } from "@azure/msal-browser";

/**
 * Helper function to get environment variables
 * Priority: Runtime config (window._env_) > Build-time config (process.env)
 * This allows the same build to work across different environments
 */
const getEnvVar = (key, defaultValue = "") => {
  // Check runtime config (injected by entrypoint.sh)
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }

  // Fallback to build-time env (for local development)
  if (process.env[key]) {
    return process.env[key];
  }

  // Return default value if neither exists
  return defaultValue;
};

export const msalConfig = {
  auth: {
    clientId: getEnvVar("REACT_APP_CLIENT_ID"),
    authority: `https://login.microsoftonline.com/${getEnvVar("REACT_APP_TENANT_ID")}`,
    redirectUri: getEnvVar("REACT_APP_REDIRECT_URI"),
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Warning,
    },
    allowRedirectBroker: false,
    windowHashTimeout: 9000,
    iframeHashTimeout: 9000,
    loadFrameTimeout: 9000,
  },
};

export const loginRequest = {
  scopes: [getEnvVar("REACT_APP_API_SCOPE")],
  prompt: "select_account",
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphPhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value",
};

// Log configuration for debugging (only in development)
if (process.env.NODE_ENV === "development") {
  console.log("Auth Configuration:", {
    clientId: getEnvVar("REACT_APP_CLIENT_ID"),
    tenantId: getEnvVar("REACT_APP_TENANT_ID"),
    redirectUri: getEnvVar("REACT_APP_REDIRECT_URI"),
  });
}
